import { Button } from 'antd';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import API from 'api';

export default function GoogleButton() {
	const [link, setLink] = useState('');

	const fetchGoogleUrl = async () => {
		await API('/auth/google/url')
			.then(d => setLink(d.data))
			.catch(console.error);
	};

	useEffect(() => {
		fetchGoogleUrl();
		// fetchDashboard();
	}, []);

	const handleClick = () => {
		if (!link) return;
		window.location.href = link;
	};

	return (
		<Button
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				// width: '400px'
				height: '80px',
				fontSize: '22px',
			}}
			block
			onClick={handleClick}
			// href={link}
			type='primary'
			disabled={!link}
		>
			<span style={{ display: 'flex', marginRight: '1rem' }}>
				<Image
					height={20}
					width={22}
					src='/assets/icons/google.svg'
					alt='veoping google icon'
				/>
			</span>
			Continue with Google
		</Button>
	);
}
